import { render, staticRenderFns } from "./GoodsDetails.vue?vue&type=template&id=91d37e86&scoped=true&"
import script from "./GoodsDetails.vue?vue&type=script&lang=js&"
export * from "./GoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetails.vue?vue&type=style&index=0&id=91d37e86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d37e86",
  null
  
)

export default component.exports